export default function GS_Format_Painter() {
  return (
    <div className="p-4">
      <h1>GS Format Painter</h1>
    </div>
  );
}
